import Guarded from '@/components/Guarded';
import MessageReceiptList from './components/MessageReceiptList';

// @todo use @tanstack/react-virtual
export default function Page() {
  return (
    <Guarded>
      <MessageReceiptList />
    </Guarded>
  );
}
